import { render, staticRenderFns } from "./AvailableOpgsMain.vue?vue&type=template&id=8b1ba27a"
import script from "./AvailableOpgsMain.vue?vue&type=script&lang=js"
export * from "./AvailableOpgsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b1ba27a')) {
      api.createRecord('8b1ba27a', component.options)
    } else {
      api.reload('8b1ba27a', component.options)
    }
    module.hot.accept("./AvailableOpgsMain.vue?vue&type=template&id=8b1ba27a", function () {
      api.rerender('8b1ba27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableOpgsMain.vue"
export default component.exports